import React from 'react'
import styles from './LoadingIcon.module.css'
import classNames from 'classnames'

interface LoadingIconProps {
  className?: string
}

export const LoadingIcon: React.FC<LoadingIconProps> = ({ className = '' }) => {
  return (
    <div className={className}>
      <div className={classNames(styles['lds-spinner'])}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  )
}
